import httpClient, { handleSuccess, handleError } from './httpClient'

export function login(email, password, adminStatus) {
  const params = new URLSearchParams()
  params.append('email', email)
  params.append('password', password)
  params.append('admin_status', adminStatus)

  return httpClient.post('auth/login', params).then(handleSuccess).catch(handleError)
}

export function logout() {
  return httpClient.post('auth/logout').then(handleSuccess).catch(handleError)
}
